import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataTablesResponse } from '../models/datatables';
import { StihlGalleryDataDTO, StihlGalleryDataLogDTO } from '../models/stihl-gallery-dto';
import { ChangeOrderDTO } from '../models/change-order-dto';
import { Select2Data } from 'ng-select2-component';
import { StihlFileDTO } from '../models/stihl-file-dto';

@Injectable({
  providedIn: 'root'
})

export class GalleryDataService {

  private pathAPI = environment.urlAPI;
  private controller = "StihlGalleryData/";

  constructor(private http: HttpClient) { }

  public get(id: string): Observable<StihlGalleryDataDTO> {
    return this.http.get<StihlGalleryDataDTO>(this.pathAPI + this.controller + id);
  }

  public post(data: FormData): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller, data);
  }

  public put(id: string, data: FormData): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + id, data);
  }

  public changeStatus(id: string, idStatus: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatus/' + id + '/' + idStatus, null);
  }

  public getDataTable(data: any, idType: string): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable/' + idType, data);
  }

  public getDataTableOrder(data: any, idType: string): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTableOrder/' + idType, data);
  }

  public changeOrder(data: ChangeOrderDTO[]): any {
    return this.http.post<any>(this.pathAPI + this.controller + 'ChangeOrder', data);
  }

  public getGalleryType(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'getGalleryType');
  }

  public getGalleryCampaign(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'getGalleryCampaign');
  }

  public getGalleryCategory(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'getGalleryCategory');
  }

  public getGalleryFormat(): Observable<Select2Data> {
    return this.http.get<Select2Data>(this.pathAPI + this.controller + 'getGalleryFormat');
  }

  public getFile(file: StihlFileDTO): Observable<Blob> {

    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetFile/';

    return this.http.post<Blob>(endpoint, file, requestOptions);
  }

  public InsertLog(data: StihlGalleryDataLogDTO): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller + 'InsertLog', data);
  }



}
